<template>
  <button
    :class="[buttonStyle, iconStyle && iconStyle.iconPosition === 'left' && 'justify-center','flex items-center text-white rounded-lg outline-none border-0 cursor-pointer font-semibold disabled:bg-cold-morning disabled:hover:bg-cold-morning disabled:text-silver disabled:cursor-not-allowed', !iconStyle && 'justify-center']"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <!-- Left Icon -->
    <shipblu-icon v-if="iconStyle && iconStyle.LeftIconName && ['left', 'both'].includes(iconStyle.iconPosition)" :iconLibrary="iconStyle.LeftIconLibrary" :iconClass="iconClass('LeftIconLibrary')" :iconName="iconStyle.LeftIconName"/>

    <!-- Button Text -->
    <span v-if="textButton">{{ textButton }}</span>

    <!-- Right Icon -->
    <shipblu-icon v-if="iconStyle && iconStyle.RightIconName && ['right', 'both'].includes(iconStyle.iconPosition)" :iconLibrary="iconStyle.RightIconLibrary" :iconClass="iconClass('RightIconLibrary')" style="margin-left: auto;" :iconName="iconStyle.RightIconName" @click="handleRightIconClick($event)"/>
  </button>
</template>

<script>
export default {
  name: 'ShipbluButton',
  props: {
    size: {
      type: String,
      default: 'normal'
    },
    textButton: {
      type: String
    },
    color: {
      type: String,
      default: 'primary'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    iconStyle: {
      type: Object
    }
  },
  data () {
    return {
      colors: {
        primary: 'bg-primary hover:bg-c64-ntsc',
        secondary: 'bg-polished-metal hover:bg-supremely-cool',
        danger: 'bg-fluorescent-red hover:bg-embarrassment'
      },
      sizes: {
        normal: 'h-[42px] text-[16px] px-[16px] py-[10px] gap-[6px]',
        small: 'h-[36px] text-[14px] px-[12px] py-[8px] gap-[4px]'
      }
    }
  },
  computed: {
    windowWidth () { return this.$store.state.windowWidth },
    responseSize () { return this.windowWidth > 768 ? this.size : 'small' },
    buttonStyle () {
      const sizeClass = this.sizes[this.responseSize] || this.sizes.normal
      const colorClass = this.colors[this.color] || this.colors.primary
      return `${sizeClass} ${colorClass}`
    }
  },
  methods: {
    iconClass (iconLibraryKey) {
      const library = this.iconStyle[iconLibraryKey]
      const isFeather = library === 'feather'
      const sizeClasses = isFeather ? 'w-[16px] h-[16px]' : 'text-[16px]' 
      return `${this.iconStyle.iconClass} ${sizeClasses}`
    },
    handleRightIconClick (event) {
      event.stopPropagation()
      this.$emit('right-icon-click')
    }
  }
}
</script>